import React from 'react';

import { EmailFormValues, EmailFormViolation } from 'types/emailFormTypes';

const initialValues: EmailFormValues = {
  email: '',
};

export const useEmailForm = () => {
  const [values, setValues] = React.useState<EmailFormValues>(initialValues);

  const [violations, setViolations] = React.useState<EmailFormViolation[]>([]);

  const setEmailValue = React.useCallback((nextValue: string) => {
    setValues({ email: nextValue });

    setViolations([]);
  }, []);

  return { values, violations, setValues, setViolations, setEmailValue };
};
